export default class is_localhost {

    return_url_website(){
        let url = window.location.host;
        if (url.toString().includes('localhost')){
          this.url = 'http://localhost/vistosiwoocommerce/';
   
        } else {
           this.url = 'https://'+url+'/';
        }
        return this.url;
    }
    is_localhost(){
      let url = window.location.host;
      if (url.toString().includes('localhost')){
        return true;
      }else {
        return false;
      }
    }

}